import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Searchbar from '../../components/Searchbar/Searchbar';
import ArrowDownIcon from '../../assets/icons/table/arrow-down.svg';
import './MesReceiversModal.css';

function MesReceiversModal({ receivers, onClose }) {
  const [searchValue, setSearchValue] = useState('');
  const [sortBy, setSortBy] = useState({ column: 'name', ascending: true });

  useEffect(() => {
    const modalElement = document.getElementById('mesReceiversModal');
    const handleShow = () => {
      setSearchValue('');
      setSortBy({ column: 'name', ascending: true });
    };

    modalElement.addEventListener('show.bs.modal', handleShow); 
    return () => {
      modalElement.removeEventListener('show.bs.modal', handleShow); 
    };
  }, []);
  receivers.forEach((receiver)=>{
    if(receiver.name === null || receiver.name === undefined){
      receiver.name = "";
    }
  })
  const sortedReceivers = [...(receivers || [])]
    .filter(receiver =>
      receiver.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      receiver.status.toLowerCase().includes(searchValue.toLowerCase())
    )
    .sort((a, b) => {
      const column = sortBy.column;
      const order = sortBy.ascending ? 1 : -1;
      return a[column].localeCompare(b[column]) * order;
    });

  const handleSort = (column) => {
    setSortBy((prevSortBy) => ({
      column,
      ascending: prevSortBy.column === column ? !prevSortBy.ascending : true,
    }));
  };

  const SortableHeader = ({ columnKey, labelId, sortBy, handleSort }) => (
    <th onClick={() => handleSort(columnKey)}>
      <div className="d-flex justify-content-between align-items-center">
        <FormattedMessage id={labelId} />
        {sortBy.column === columnKey && (
          <img
            src={ArrowDownIcon}
            alt="Sort Icon"
            className={`sort-icon ${sortBy.ascending ? 'up' : 'down'}`}
          />
        )}
      </div>
    </th>
  );

  return (
    <div className="modal modal-mse fade" id="mesReceiversModal" tabIndex="-1" aria-labelledby="mesReceiversModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content modal-mes-content">
          <div className="modal-header modal-mes-header" style={{ backgroundColor: '#347BFA' }}>
            <h5 className="modal-title modal-mes-title" id="mesReceiversModalLabel"><FormattedMessage id="RECEIVERS" /></h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
          <Searchbar search={setSearchValue} value={searchValue} />
            <div className="card mt-3">
              <table className="table mesReceiversModal">
                <thead>
                  <tr>
                    <SortableHeader
                      columnKey="name"
                      labelId="RECEIVERS_NAME"
                      sortBy={sortBy}
                      handleSort={handleSort}
                    />
                    <SortableHeader
                      columnKey="status"
                      labelId="Status"
                      sortBy={sortBy}
                      handleSort={handleSort}
                    />
                  </tr>
                </thead>
                <tbody>
                  {sortedReceivers.map((receiver, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{receiver.name}</td>
                        <td>{receiver.status}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button type="button" className='btn btn-outline-secondary' data-bs-dismiss="modal" onClick={onClose}><FormattedMessage id="CLOSE" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MesReceiversModal;
